import { makeStyles } from "../../styles/index";
import React, { useMemo } from 'react';
import { IconButton } from "../IconButton/IconButton";
import { ColorButtonIcon } from "./ColorButtonIcon";
import Check from "./parts/Check";
var useStyles = makeStyles(function () { return ({
    activeIcon: {
        position: 'absolute',
        top: 0,
        left: 0,
    },
}); }, { name: 'SnColorButton' });
export var ColorButton = React.memo(function (props) {
    var iconColor = props.iconColor, _a = props.active, active = _a === void 0 ? false : _a, onClick = props.onClick, setAnchorRef = props.setAnchorRef;
    var classes = useStyles();
    var colorStyle = useMemo(function () { return ({
        color: iconColor,
    }); }, [iconColor]);
    return (React.createElement(IconButton, { ref: setAnchorRef, onClick: onClick },
        React.createElement(React.Fragment, null,
            React.createElement(ColorButtonIcon, { style: colorStyle }),
            active && React.createElement(Check, { className: classes.activeIcon }))));
});
